import { NewsboardPostProfileContext } from '../Newsboard.contexts'

function NewsboardPostProfileContextProvider({ children, ...restProps }) {
  return (
    <NewsboardPostProfileContext value={restProps}>
      {children}
    </NewsboardPostProfileContext>
  )
}

export default NewsboardPostProfileContextProvider
